/* global localize */
import React, { useContext, useEffect, Fragment, useState } from 'react';
import { motion } from 'framer-motion';
import { HashLink } from 'react-router-hash-link';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { SurveyContext } from '../context/surveyContext';
import UserInfo from '../components/UserInfo';
import RadarChart from '../components/RadarChart';
import ResultList from '../components/ResultList';
import RadarModal from '../components/RadarModal';

export default function Result() {
  const { survey, setSurvey } = useContext(SurveyContext);
  const [showModal, setShowModal] = useState(false);

  function handleOnClick() {
    setShowModal(true);
  }

  useEffect(() => {
    calculateScore();
  }, []);

  const exportPdf = () => {
    html2canvas(document.querySelector('#result')).then((canvas) => {
      let imgData = canvas.toDataURL('image/png');
      let margin = 2;
      let imgWidth = 210 - 2 * margin;
      let pageHeight = 295 - 2 * margin;
      let imgHeight = (canvas.height * imgWidth) / canvas.width;
      let heightLeft = imgHeight;

      let doc = new jsPDF('p', 'mm');
      let position = 0;

      doc.addImage(imgData, 'PNG', margin, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;

      while (heightLeft >= 0) {
        position = heightLeft - imgHeight;
        doc.addPage();
        doc.addImage(imgData, 'PNG', margin, position, imgWidth, imgHeight);
        heightLeft -= pageHeight;
      }
      doc.save('enkat-resultat.pdf');
    });
  };

  function calculateScore() {
    /**
     * Iterate resultInformation and add "score" property
     */
    survey &&
      survey.questions.forEach((question, i) => {
        question.connected_results.forEach((result, id) => {
          const score = result.weight_result * question.answer;

          if (survey.resultInformation[result.result].score) {
            survey.resultInformation[result.result].score =
              survey.resultInformation[result.result].score + score;
          } else {
            survey.resultInformation[result.result].score = score;
          }
        });
      });

    /**
     * Iterate resultInformation and add "percent" property
     */
    survey.highScoreList = [];
    survey.lowScoreList = [];

    for (const [key, value] of Object.entries(survey.resultInformation)) {
      const percent = value.score / value.maxScore;
      survey.resultInformation[key].percent = percent;

      if (percent > 0.66) {
        survey.highScoreList.push(survey.resultInformation[key]);
      } else {
        survey.lowScoreList.push(survey.resultInformation[key]);
      }
    }

    /**
     * Sort lists by percent
     */
    survey.highScoreList = survey.highScoreList.sort(
      ({ percent: a }, { percent: b }) => a - b
    );
    survey.lowScoreList = survey.lowScoreList.sort(
      ({ percent: a }, { percent: b }) => a - b
    );

    setSurvey({
      ...survey,
      resultInformation: survey.resultInformation,
      highScoreList: survey.highScoreList,
      lowScoreList: survey.lowScoreList,
    });

    console.log(survey);
  }

  return (
    <motion.div
      className='result'
      id='result'
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
    >
      {survey && (
        <Fragment>
          <section className='result-top-section'>
            <div className='result-top-section__titles'>
              <h4>Steg 3</h4>
              <h1>{survey.survey_result_title}</h1>
            </div>
            <UserInfo exportPdf={exportPdf} />
            <HashLink
              smooth
              to={`${localize.url}/resultat#radar`}
              className='anchor-link-wrapper'
            >
              <button className='anchor-link'>
                Se hela resulatet
                <svg
                  xmlns='http://www.w3.org/2000/svg'
                  width='16'
                  height='16'
                  viewBox='0 0 16 16'
                >
                  <polygon
                    fill-rule='evenodd'
                    points='3.8 7 9.4 1.4 8 0 0 8 8 16 9.4 14.6 3.8 9 16 9 16 7'
                    transform='matrix(0 -1 -1 0 16 16)'
                  />
                </svg>
              </button>
            </HashLink>
          </section>
          <RadarChart />
          {/* <div className='radar-fullscreen-link' onClick={handleOnClick}>
            <a>
              Visa diagram i helskärm
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14">
                <defs>
                  <filter id="icon-fullscreen-a">
                    <feColorMatrix in="SourceGraphic" values="0 0 0 0 0.073349 0 0 0 0 0.073349 0 0 0 0 0.073349 0 0 0 1.000000 0"/>
                  </filter>
                </defs>
                <g fill="none" fill-rule="evenodd" filter="url(#icon-fullscreen-a)" transform="translate(-177 -6)">
                  <path fill="#131313" fill-rule="nonzero" d="M2,9 L0,9 L0,14 L5,14 L5,12 L2,12 L2,9 Z M0,5 L2,5 L2,2 L5,2 L5,0 L0,0 L0,5 Z M12,12 L9,12 L9,14 L14,14 L14,9 L12,9 L12,12 Z M9,0 L9,2 L12,2 L12,5 L14,5 L14,0 L9,0 Z" transform="translate(177 6)"/>
                </g>
              </svg>
            </a>
          </div> */}
          {showModal && <RadarModal setShowModal={setShowModal} />}
          <ResultList exportPdf={exportPdf} />
        </Fragment>
      )}
    </motion.div>
  );
}
